export default {"src":"/accounts/_next/static/media/projectBlue.3b83986c.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};